<template>
  <div class="jdTemps bg_fff">
    <div class="head clearfix">
      <div class="title fl f_24 color_40 font_w_b">选择模板 发布职位</div>
      <div class="text fl f_14 color_90">请根据对应的行业，选择你想招的职业</div>
    </div>
    <div class="content pr">
      <div class="left pa">
        <div class="search">
          <!-- 智能联想 -->
          <el-autocomplete class="searchJdTemps f_14 color_40" popper-class="searchJdTempsAutocomplete" :maxlength="50" placeholder="搜索职位" v-model="jdTempsValue" :fetch-suggestions="jdTempsSearch" @select="handleJdTemps" @blur="jdTempsBlur" >
            <template slot-scope="{item}">
              <div class="item" v-if="item.id!==-1">
                <div class="title" v-html="item.level3"></div>
                <div class="name" v-html="item.name"></div>
              </div>
              <div class="emptyState" v-else>暂无数据 </div>
            </template>
          </el-autocomplete>
        </div>
        <div class="list">
          <template v-for="(item,index) in level1List">
            <div class="item cursor_p f_16 pr transition_2"
              :key="String(index)" :class="query.level1 === item?'active color_40 bg_fff':'color_90'"
              @click="toggleLevel1(item)"
            >{{item}}</div>
          </template>
        </div>
      </div>
      <div class="right" v-loading="isLoading">
        <div class="list">
          <template v-if="windowInnerWidth>1400">
            <div class="list1" v-for="(item,index) in level2List1" :key="String(index)">
              <div class="clearfix">
                <template v-for="(sitem,sindex) in item">
                  <div class="level2 fl cursor_p transition_2" :class="highlight(sitem)?'active':''" :key="String(sindex)" @click="toggleLevel2(sitem,index)">
                    <div class="title color_0 f_14">{{sitem.name}}</div>
                    <div class="text color_a6 f_12">{{sitem.count}} 个职业，{{sitem.jd_count}} 个模板</div>
                  </div>
                </template>
              </div>
              <div class="level3list clearfix" v-if="level3List.length && level2Index===index">
                <!-- <div class="level3Name fl color_40 f_14 cursor_p transition_2" v-for="(sitem,sindex) in level3List" :key="String(sindex)" @click="clickLevel3(sitem)">{{sitem.name}}</div> -->
                <a class="level3Name fl color_9c f_14 cursor_p transition_2 ellipsis width25" v-for="(sitem,sindex) in level3List" :key="String(sindex)" :href="`/talent/jd_temps/${sitem.profession_id}`">{{sitem.name}}</a>
                
              </div>
            </div>
          </template>
          <template v-else>
            <div class="list2" v-for="(item,index) in level2List2" :key="String(index)">
              <div class="clearfix">
                <template v-for="(sitem,sindex) in item">
                  <div class="level2 fl cursor_p transition_2" :class="highlight(sitem)?'active':''" :key="String(sindex)" @click="toggleLevel2(sitem,index)">
                    <div class="title color_0 f_16">{{sitem.name}}</div>
                    <div class="text color_a6 f_12">{{sitem.count}} 个职业，{{sitem.jd_count}} 个模板</div>
                  </div>
                </template>
              </div>
              <div class="level3list clearfix" v-if="level3List.length && level2Index===index">
                <!-- <div class="level3Name fl color_40 f_14 cursor_p transition_2 width33" v-for="(sitem,sindex) in level3List" :key="String(sindex)">{{sitem.name}}</div> -->
                <a class="level3Name fl color_9c f_14 cursor_p transition_2 ellipsis width33" v-for="(sitem,sindex) in level3List" :key="String(sindex)" :href="`/talent/jd_temps/${sitem.profession_id}`">{{sitem.name}}</a>
              </div>
            </div>
          </template>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
// 所有接口
import actions from '@/actions/index'
//混入优化
import {mixinsUtils} from '@/mixins/search/utils';

import {checkUserState, get_tUser , toLogin} from '@/utils/utils';


export default {
  name: 'jdTemps',
  data(){
    return {
      query:{
        level1:'热门',
      },
      level2Query:{
        level1:'',
        level2:'',
      },
      level1List:[],//1级list
      level2List:[],//2级list
      level2List1:[],//2级list-2个一组
      level2List2:[],//2级list-3个一组
      level2Index:'',//二级内容
      level3List:[],//3级list

      jdTempsValue:'',//搜索关键词
      jdTempsList:[],//搜索列表

      isLoading:false,//是否在请求列表
      userJWT:{},
    }
  },
  computed:{
    ...mapState('block',['userInfoState','windowInnerWidth']),
  },
  mixins:[mixinsUtils],
  async created(){
    this.userJWT = await get_tUser();
    if(this.userJWT.h_t){
      //更新是否完善信息(状态库)
      let userInfo = await actions.hr_accounts.getUserinfo();
      this.toggleUserInfoState(userInfo)
    }else{
      this.toggleUserInfoState(false)
    }
    //获取列表
    this.getList();
  },
  methods:{
    ...mapMutations('block',['toggleUserInfoState']),
    getList(){
      if(this.isLoading){
        return false;
      }
      let { level1 } = this.query;
      let data = {
        level1:level1 ==='热门'?'':level1
      }
      this.isLoading = true;
      actions.jd_temps.get_jd_temps_list(data).then(res=>{
        this.isLoading = false;
        if(res.code=== 1000){
          let { level1_keys, level2s } = res.data;
          if(!data.level1){
            this.level1List = level1_keys
          }
          this.level2List1=[];
          this.level2List2=[];
          level2s.forEach((item,index)=>{
            let index1 = Math.floor(index/3);
            let index2 = Math.floor(index/2);
            if(!this.level2List1[index1]){
              this.level2List1[index1] = [];
            }
            if(!this.level2List2[index2]){
              this.level2List2[index2] = [];
            }
            this.level2List1[index1].push(item)
            this.level2List2[index2].push(item)
          })
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //切换以及标题
    toggleLevel1(item){
      this.query.level1 = item;
      //重置二级选中状态
      this.level2Query = {
        level1:'',
        level2:'',
      };
      this.level3List = [];
      this.level2List = [];//2级list
      this.level2List1 = [];//2级list-2个一组
      this.level2List2 = [];//2级list-3个一组
      this.getList();
    },
    //切换以及标题
    toggleLevel2(item,index){
      let { level1 } = this.query;
      this.level2Query = {
        level1:level1 ,
        level2:item.name,
      };
      this.level2Index = index;
      this.level3List = [];
      //获取三级列表
      this.getLevel3List();
    },
    //获取三级列表
    getLevel3List(){
      actions.jd_temps.get_jd_temps_level3_list(this.level2Query).then(res=>{
        if(res.code=== 1000){
          this.level3List = res.data;
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //点击三级
    clickLevel3(item){
      let level4 = item.profession_id;
      console.log(item, !level4)
      if(!level4){
        return false;
      }
      this.$router.push({path:`/talent/jd_temps/${level4}`})
    },

    //【搜索】搜索公司名称
    jdTempsSearch(queryString, cb) {
      //搜索词一致，不进行搜索
      this.jdTempsList = [];
      this.jdTempsValue = queryString ? queryString.trim() : '';
      cb([]);
      if(!this.jdTempsValue.length){
        return false;
      }
      actions.jd_temps.search_jd_temp({name: queryString,	type:'pc' }).then(res=>{
        if(res.code === 1000){
          let { jd_temps } = res.data;
          jd_temps.forEach(item=>{

            item.level3 = this.highlightHtml(item.level3, queryString);
            let level1 = this.highlightHtml(item.level1, queryString);
            let level2 = this.highlightHtml(item.level2, queryString);
            // let name = this.highlightHtml(item.name, queryString);
            item.name = `${level1} - ${level2}`;
          })
          this.jdTempsList = JSON.parse(JSON.stringify(jd_temps));
          // 调用 callback 返回建议列表的数据
          if(jd_temps.length){
            cb([...jd_temps]);
          }else{
            cb([{
              id:-1,
            }])
          }
          
        }
      })
      
    },
    //【搜索】点击筛选项
    handleJdTemps(item) {
      if(item.id === -1){
        return false;
      }
      let level4 = item.profession_id;
      if(!level4){
        return false;
      }
      this.$router.push({path:`/talent/jd_temps/${level4}`})
    },
    //【搜索】失焦
    jdTempsBlur(){
      this.jdTempsList = [];
      this.jdTempsValue = '';
    },

    //判断是否高亮
    highlight(item){
      let { level2 } = this.level2Query;
      return item.name === level2
    },
    highlightHtml(text,searchValue){
      //搜索词转小写
      searchValue = searchValue.toLowerCase();
      // 标题转小写
      let textLowerCases = text.toLowerCase().split(searchValue);
      let highlightHtml = "";
      let newText = '';
      if(text.toLowerCase() === searchValue.toLowerCase()){
        return `<span class='color_blue'>${searchValue}</span>`
      }
      textLowerCases.forEach((item,index)=>{
        if(item===''){
          let Text = text.substring(newText.length<1?0:newText.length,searchValue.length)
          highlightHtml += `<span class='color_blue'>${searchValue}</span>`
        }else{
          highlightHtml += item
        }
      })

      return highlightHtml
    },
  },
  watch:{
    'windowInnerWidth'(){
      this.level2Index = 0;
      this.level3List = [];
    }
  }
}
</script>
<style lang="scss" scoped>

@import './Index.scss';

</style>
